import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import AutocompleteSelect from "../../../../ui/components/autocomplete-select/autocomplete-select";
import CustomInput from "../../../../ui/components/custom-input/custom-input";
import CustomModal from "../../../../ui/components/custom-modal/custom-modal";
import CustomSelect from "../../../../ui/components/custom-select/custom-select";
import DateInput from "../../../../ui/components/date-input/date-input";
import { ListModel } from "../../../models/list-model";
import { PracticaSempre } from "../../../models/practica-sempre";
import { afiliadoSempreServices } from "../../../services/afiliado-sempre.services";
import { prestadorSempreServices } from "../../../services/prestador-sempre.services";
import {
  initialFilter,
  queryParamsConfig,
} from "../../../utils/afiliado-sempre.utils";
import { formBonos } from "../../../utils/practica-sempre.utils";
import {
  initialFilterPrestador,
  queryParamsPrestadorConfig,
} from "../../../utils/prestador-sempre.utils";
import { useQueryParamsReplace } from "../../../utils/useQueryParamsReplace";
import "./practica-sempre-modal.scss";

interface QueryParams {
  page: number;
  search?: string;
}

export interface PracticaSempreModalProps {
  show: boolean;
  handleClose: (success: boolean, item: any) => void;
}

export function PracticaSempreModal(props: PracticaSempreModalProps) {
  const { show, handleClose } = props;
  const [afiliadosSempre, setAfiliadosSempre] = useState<ListModel[]>([]);
  const [prestadoresSempre, setPrestadoresSempre] = useState<ListModel[]>([]);
  const [queryParamsAfiliadoSempre, setQueryParamsAfiliadoSempre] =
    useQueryParamsReplace(queryParamsConfig);
  const [queryParamsPrestadorSempre, setQueryParamsPrestadorSempre] =
    useQueryParamsReplace(queryParamsPrestadorConfig);

  const [formBonoSeries, setFormBonoSeries] = useState<ListModel[]>([]);
  const [formTipos] = useState<ListModel[]>([
    { value: "3", label: "Sin Marcas" },
    { value: "4", label: "Planes Especiales" },
    { value: "44", label: "Internado" },
    { value: "5", label: "Hemodiálisis" },
  ]);

  const schema = yup
    .object()
    .shape({
      prescriptorId: yup.string().trim().required("Campo requerido"),
      afiliadoId: yup.string().trim().required("Campo requerido"),
      formBonoSerie: yup.string().trim(),
      formBonoNum: yup
        .string()
        .trim()
        .max(8, "8 Máximo")
        .required("Campo requerido"),
      formBonoSubNum: yup.string().trim(),
      formTipo: yup.string().trim().required("Campo requerido"),
      fechaPrescripcion: yup.date().required("Campo requerido"),
      fechaAutorizacion: yup.date().required("Campo requerido"),
      codigoDiagnosticoI: yup
        .string()
        .trim()
        .max(5, "5 Máximo")
        .required("Campo requerido"),
      codigoDiagnosticoII: yup.string().trim().max(5, "5 Máximo"),
      codigoDiagnosticoIII: yup.string().trim().max(5, "5 Máximo"),
      internacionNumero: yup.string().trim().max(6, "6 Máximo"),
      numeroValidacion: yup.string().trim().required("Campo requerido"),
      afiliadoDescripcion: yup.string().trim().required("Campo requerido"),
    })
    .required();

  const {
    register,
    getFieldState,
    formState,
    handleSubmit,
    formState: { errors },
    setError,
    watch,
    control,
    setValue,
  } = useForm<PracticaSempre>({
    mode: "all",
    resolver: yupResolver(schema),
  });

  const handleSubmitSempreData = (data: any) => {
    data.fechaPrescripcion.setHours(0, 0, 0, 0);
    data.fechaAutorizacion.setHours(0, 0, 0, 0);
    props.handleClose(true, data);
  };

  const checkDisabledButton = () => {
    if (
      !watch("prescriptorId") ||
      !watch("afiliadoId") ||
      !watch("formBonoNum") ||
      !watch("formTipo") ||
      !watch("fechaPrescripcion") ||
      !watch("fechaAutorizacion") ||
      !watch("codigoDiagnosticoI") ||
      !watch("numeroValidacion")
    )
      return true;

    return false;
  };

  const ActionsComponent = () => {
    return (
      <>
        <Button
          className="close-button"
          onClick={(e) => {
            handleClose(false, null);
          }}
        >
          Cancelar
        </Button>
        <Button
          className="create-button"
          variant="contained"
          onClick={handleSubmit((data) => handleSubmitSempreData(data))}
          disabled={checkDisabledButton()}
        >
          Guardar
        </Button>
      </>
    );
  };

  const getAfiliados = async (searchValue: string) => {
    setQueryParamsAfiliadoSempre({ ...initialFilter, search: searchValue });
    afiliadoSempreServices
      .lookup(queryParamsAfiliadoSempre)
      .then((response) => {
        const items: ListModel[] = [];
        response.data.forEach((element: any) => {
          items.push({
            value: element.id,
            label: element.cuil + " - " + element.apellidoNombre,
          });
        });
        setAfiliadosSempre(items);
      })
      .catch((error) => {
        // setDisabled(true);
      });
  };

  const getPrestadores = async (searchValue: string) => {
    setQueryParamsPrestadorSempre({
      ...initialFilterPrestador,
      search: searchValue,
    });
    prestadorSempreServices
      .lookup(queryParamsPrestadorSempre)
      .then((response) => {
        const items: ListModel[] = [];
        response.data.forEach((element: any) => {
          items.push({
            value: element.id,
            label: element.matricula + " - " + element.nombre,
          });
        });
        setPrestadoresSempre(items);
      })
      .catch((error) => {
        // setDisabled(true);
      });
  };

  useEffect(() => {
    setFormBonoSeries(formBonos);
  }, []);

  useEffect(() => {
    if (watch("afiliadoId")) {
      const afiliadoSelected = afiliadosSempre.find(
        (a) => a.value === watch("afiliadoId")
      );
      if (afiliadoSelected)
        setValue("afiliadoDescripcion", afiliadoSelected.label, {
          shouldTouch: true,
          shouldDirty: true,
          shouldValidate: true,
        });
    }
  }, [watch("afiliadoId")]);

  return (
    <CustomModal
      show={show}
      handleClose={() => handleClose(false, null)}
      title="Datos Práctica Sempre"
      actions={<ActionsComponent />}
      size="lg"
    >
      <div className="practica-sempre-modal">
        <Box
          sx={{ height: 400 }}
          component="form"
          autoComplete="off"
          onSubmit={handleSubmitSempreData}
        >
          <div className="row w-100">
            <div className="w-50">
              <AutocompleteSelect
                name="afiliadoId"
                label="Paciente"
                isMultiple={false}
                register={register}
                getFieldState={getFieldState}
                formState={formState}
                errors={errors}
                required={true}
                options={afiliadosSempre}
                onChange={(value) =>
                  setValue("afiliadoId", value, {
                    shouldTouch: true,
                    shouldDirty: true,
                    shouldValidate: true,
                  })
                }
                handleCreate={getAfiliados}
                helperText="Para comenzar la búsqueda escriba al menos 3 caracteres"
              ></AutocompleteSelect>
            </div>
            <div className="w-50">
              <AutocompleteSelect
                name="prescriptorId"
                label="Profesional"
                isMultiple={false}
                register={register}
                getFieldState={getFieldState}
                formState={formState}
                errors={errors}
                required={true}
                options={prestadoresSempre}
                onChange={(value) =>
                  setValue("prescriptorId", value, {
                    shouldTouch: true,
                    shouldDirty: true,
                    shouldValidate: true,
                  })
                }
                handleCreate={getPrestadores}
                helperText="Para comenzar la búsqueda escriba al menos 3 caracteres"
              ></AutocompleteSelect>
            </div>
          </div>

          <div className="row">
            <div className="w-25">
              <Controller
                name="formBonoSerie"
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    field={field}
                    name="formBonoSerie"
                    label="Form. Bono Serie"
                    isMultiple={false}
                    register={register}
                    getFieldState={getFieldState}
                    formState={formState}
                    errors={errors}
                    required={true}
                    options={formBonoSeries}
                  ></CustomSelect>
                )}
              />
            </div>
            <div className="w-25">
              <CustomInput
                name="formBonoNum"
                label="Form. Bono Número"
                type="number"
                register={register}
                getFieldState={getFieldState}
                formState={formState}
                errors={errors}
                required={true}
                max={9999999}
                min={0}
              ></CustomInput>
            </div>
            <div className="w-25">
              <CustomInput
                name="formBonoSubNum"
                label="Form. Bono Sub Número"
                type="number"
                register={register}
                getFieldState={getFieldState}
                formState={formState}
                errors={errors}
                required={false}
                max={9}
                min={0}
              ></CustomInput>
            </div>
            <div className="w-25">
              <Controller
                name="formTipo"
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    field={field}
                    name="formTipo"
                    label="Form. Tipo"
                    isMultiple={false}
                    register={register}
                    getFieldState={getFieldState}
                    formState={formState}
                    errors={errors}
                    required={true}
                    options={formTipos}
                  ></CustomSelect>
                )}
              />
            </div>
          </div>

          <div className="row">
            <Controller
              name="fechaPrescripcion"
              control={control}
              render={({ field }) => (
                <DateInput
                  field={field}
                  name="fechaPrescripcion"
                  label="Fecha Prescripción"
                  register={register}
                  getFieldState={getFieldState}
                  formState={formState}
                  errors={errors}
                  required={true}
                  value={field.value}
                  // minDate={new Date()}
                ></DateInput>
              )}
            />
            <Controller
              name="fechaAutorizacion"
              control={control}
              render={({ field }) => (
                <DateInput
                  field={field}
                  name="fechaAutorizacion"
                  label="Fecha Autorización"
                  register={register}
                  getFieldState={getFieldState}
                  formState={formState}
                  errors={errors}
                  required={true}
                  value={field.value}
                  // minDate={new Date()}
                ></DateInput>
              )}
            />
            <CustomInput
              name="numeroValidacion"
              label="Número Validación Online"
              type="number"
              register={register}
              getFieldState={getFieldState}
              formState={formState}
              errors={errors}
              required={false}
              max={9999999999}
              min={0}
            ></CustomInput>
          </div>

          <div className="row">
            <CustomInput
              name="codigoDiagnosticoI"
              label="Código Diagnóstico I"
              type="text"
              register={register}
              getFieldState={getFieldState}
              formState={formState}
              errors={errors}
              required={true}
              maxLength={5}
            ></CustomInput>

            <CustomInput
              name="codigoDiagnosticoII"
              label="Código Diagnóstico II"
              type="text"
              register={register}
              getFieldState={getFieldState}
              formState={formState}
              errors={errors}
              required={false}
              maxLength={5}
            ></CustomInput>

            <CustomInput
              name="codigoDiagnosticoIII"
              label="Código Diagnóstico III"
              type="text"
              register={register}
              getFieldState={getFieldState}
              formState={formState}
              errors={errors}
              required={false}
              maxLength={5}
            ></CustomInput>

            <CustomInput
              name="internacionNumero"
              label="Número Internación"
              type="text"
              register={register}
              getFieldState={getFieldState}
              formState={formState}
              errors={errors}
              required={false}
              maxLength={6}
            ></CustomInput>
          </div>
        </Box>
      </div>
    </CustomModal>
  );
}

export default PracticaSempreModal;
